let cached = null;
export async function getCardsPool() {
  if (cached) return cached;
  const res = await fetch("/cards-pool.json");
  if (!res.ok) throw new Error("cards-pool.json fetch failed");
  cached = await res.json();
  return cached;
}
